import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "@main-services/auth-guard.service";
import { NgModule } from "@angular/core";
import { PortfolioModalRoutes } from "@modules/portfolio/modal/portfolio-modal-routes";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";

export const routes: Routes = [
	{
		outlet: ROUTER_OUTLET_NAME,
		path: PortfolioModalRoutes.BasePath,
		loadChildren: () =>
			import("app/modules/portfolio/modal/portfolio-modal-routing.module").then(
				(m) => m.PortfolioModalRoutingModule
			),
		canActivate: [AuthGuard]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)]
})
export class PortfolioEntryModalModule {}
